const STORAGE_KEY = 'verified_user_dismiss';

const storeDismiss = (): void => {
  localStorage.setItem(STORAGE_KEY, 'y');
};

const isDismissed = (): boolean => localStorage.getItem(STORAGE_KEY) === 'y';

export { storeDismiss, isDismissed };
